import { H1 } from "@holigral/shared/ui/components"
import AssignmentsTable from "./AssignmentsTable"
import type { AssignmentsTableSearch } from "./AssignmentsTable"
import SendAssignmentsForm from "./SendAssignmentsForm"
import { useT } from "@/i18n"

type Props = {
  readonly search: AssignmentsTableSearch
  readonly onSearchChange: (partial: AssignmentsTableSearch) => void
}

export default function AssignmentsPage({ search, onSearchChange }: Props) {
  const { t } = useT("assignment")

  return (
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-6 py-8">
      <H1>{t("title")}</H1>
      <SendAssignmentsForm />
      <AssignmentsTable search={search} onSearchChange={onSearchChange} />
    </div>
  )
}
